import { graphql } from '@apollo/client/react/hoc'

import { ApplicationError, NotFoundError } from '../../../helpers/errors'
import getPaymentMethodsFromRetailer from '../../../helpers/get-payment-methods-from-retailer'
import getLogoFromRetailer from '../../../helpers/get-logo-from-retailer'
import getImageFromEntry, {
  MASTER,
} from '../../../helpers/get-image-from-entry'
import query from './query'

const mapPropsToOptions = (): Record<string, unknown> => ({
  variables: {
    slugQuery: 'fields.slug=doncaster',
  },
  errorPolicy: 'ignore',
})

const mapDataToProps: (a: any) => Record<string, unknown> = ({
  data: { loading, error, centres },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!centres[0]) {
    return {
      error: new NotFoundError(error),
    }
  }

  const centre = centres[0]

  const stores = centre.stores.entries
    .map((store: any) => ({
      ...store,
      callsToAction: store.callsToAction || store.retailer.callsToAction || [],
      heroImage: getImageFromEntry(store, MASTER),
      id: store.sys.id,
      logo: getLogoFromRetailer(store.retailer),
      longDescription: store.longDescription || store.retailer.longDescription,
      paymentMethods: getPaymentMethodsFromRetailer(store),
    }))
    .sort((storeA: any, storeB: any) =>
      storeA.title.localeCompare(storeB.title)
    )
    .filter(
      (store: any) =>
        (store.experiences || []).filter((e: any) => e.slug === 'dining')
          .length > 0 ||
        (store.retailer.experiences || []).filter(
          (e: any) => e.slug === 'dining'
        ).length > 0
    )

  return { stores }
}

const withDiningStores = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
} as any)

export default withDiningStores
